import { Component, OnInit } from '@angular/core';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { EventsService } from 'src/app/_core/_services/events.service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/_core/_services/login.service';
import { GlobalService } from 'src/app/_core/global.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

  public slideLeft: boolean = false;
  
  public User$: any = {};
  public UserSubscribed$: boolean;
  public cmsSetts$: any;

  constructor(
    private router: Router,
    public beh: BehaviorService,
    private event: EventsService,
    public loginSvc: LoginService,
    public global: GlobalService
  ) {
    this.beh.UserAccount.subscribe(u => { this.User$ = u });
    this.beh.UserSubscription.subscribe(userSub => { this.UserSubscribed$ = !!userSub?.subscriptions?.length });

    this.beh.initialCmsSetts.subscribe(cms => { this.cmsSetts$ = cms });

    this.beh.showSideNav.subscribe(val => { setTimeout(() => { this.slideLeft = val }, 0) });
  }

  ngOnInit() { }

  public eventRegist(et) {
    this.event.eventStart({ eventType: et, eventCategory: 'CLICK' });
  }

  public gotoSearch(val) {
    this.beh.showSideNav.next(false);
    this.router.navigate(['search'], { queryParams: { q: val }, queryParamsHandling: 'merge' })
  }

}